import { useState, useEffect } from "react";
import { api } from "../api/client";

export default function SsoEinstellungen() {
  const [config, setConfig] = useState(null);
  const [form, setForm] = useState({ enabled: false, display_name: "", issuer: "", client_id: "", client_secret: "", admin_group_name: "" });
  const [testErgebnis, setTestErgebnis] = useState(null);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");
  const [loading, setLoading] = useState(false);
  const [testing, setTesting] = useState(false);

  const laden = () => {
    api.getSsoConfig().then(d => {
      setConfig(d);
      if (d.configured) {
        setForm({
          enabled: d.enabled, display_name: d.display_name,
          issuer: d.issuer, client_id: d.client_id, client_secret: "",
          admin_group_name: d.admin_group_name || "",
        });
      }
    });
  };

  useEffect(() => { laden(); }, []);

  const testen = async () => {
    setTesting(true); setError(""); setTestErgebnis(null);
    try {
      const d = await api.testSsoConfig(form);
      setTestErgebnis(d);
    } catch (e) {
      setError("Verbindungstest fehlgeschlagen - Issuer nicht erreichbar oder ungültige Discovery-Antwort");
    } finally { setTesting(false); }
  };

  const speichern = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setOk("");
    try {
      await api.updateSsoConfig(form);
      setOk("Gespeichert.");
      laden();
    } catch (e) {
      setError("Fehler beim Speichern");
    } finally { setLoading(false); }
  };

  if (!config) return null;

  return (
    <div style={{ padding: 24, maxWidth: 560 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Single Sign-On (SSO)</h1>
      <div style={{ fontSize: 13, color: "#666", marginBottom: 24 }}>
        Ermöglicht Login über einen externen Identity Provider (z.B. Keycloak) statt nur über
        das interne Passwort-Login. Aktuell unterstützt das Frontend Keycloak-kompatible Provider.
      </div>

      {error && <div style={{ background: "var(--danger-bg)", color: "var(--danger)", padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 13 }}>{error}</div>}
      {ok && <div style={{ background: "#e8f5e9", color: "var(--ok)", padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 13 }}>{ok}</div>}

      <form onSubmit={speichern} className="card" style={{ padding: 20 }}>
        <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16, fontSize: 14 }}>
          <input type="checkbox" checked={form.enabled}
                 onChange={e => setForm({ ...form, enabled: e.target.checked })} />
          SSO aktiviert
        </label>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4 }}>Anzeigename</div>
          <input className="form-control" value={form.display_name}
                 onChange={e => setForm({ ...form, display_name: e.target.value })}
                 placeholder="z.B. Mit Firmen-Login anmelden" required />
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4 }}>Issuer-URL</div>
          <input className="form-control" value={form.issuer}
                 onChange={e => setForm({ ...form, issuer: e.target.value })}
                 placeholder="https://auth.example.com/realms/MeinRealm" required />
          <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
            Bei Keycloak: die Basis-URL + <code>/realms/&lt;Realm-Name&gt;</code>
          </div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4 }}>Client-ID</div>
          <input className="form-control" value={form.client_id}
                 onChange={e => setForm({ ...form, client_id: e.target.value })} required />
        </div>

        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4 }}>
            Client-Secret {config.client_secret_set && <span style={{ color: "#999", fontWeight: 400 }}>(bereits gesetzt - leer lassen zum Beibehalten)</span>}
          </div>
          <input type="password" className="form-control" value={form.client_secret}
                 onChange={e => setForm({ ...form, client_secret: e.target.value })}
                 placeholder={config.client_secret_set ? "•••••••• (unverändert lassen)" : "Nur bei vertraulichen Clients nötig"} />
        </div>

        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4 }}>
            Admin-Gruppe (optional)
          </div>
          <input className="form-control" value={form.admin_group_name}
                 onChange={e => setForm({ ...form, admin_group_name: e.target.value })}
                 placeholder="z.B. vorstand-admin oder /verein/vorstand-admin" />
          <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
            Mitglieder dieser Keycloak-Gruppe gelten automatisch als App-Admin, unabhängig von
            Keycloak-Rollen. Leer lassen, um Admin-Zugriff ausschließlich über Keycloak-Rollen zu steuern.
          </div>
        </div>

        {testErgebnis && (
          <div style={{
            background: testErgebnis.ok ? "#e8f5e9" : "var(--danger-bg)",
            padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 12
          }}>
            {testErgebnis.ok ? "✓ Discovery erfolgreich, Provider erreichbar." : "Fehler beim Verbindungstest."}
            {testErgebnis.hinweis && <div style={{ marginTop: 6, color: "var(--warn)" }}>{testErgebnis.hinweis}</div>}
          </div>
        )}

        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" className="btn btn-secondary" onClick={testen} disabled={testing || !form.issuer}>
            {testing ? "Wird geprüft…" : "Verbindung testen"}
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Wird gespeichert…" : "Speichern"}
          </button>
        </div>
      </form>
    </div>
  );
}
